if (!customElements.get('peakride-booking-form')) {
  customElements.define(
    'peakride-booking-form',
    class PeakrideBookingForm extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;

        this.initialized = true;

        this.form = this.querySelector('form');

        this.variantInput = this.querySelector(
          '[data-booking-variant]'
        );

        this.variantsJson = this.querySelector(
          '[data-booking-variants]'
        );

        this.birthdate = this.querySelector(
          '[data-booking-birthdate]'
        );

        this.skill = this.querySelector(
          '[data-booking-skill]'
        );

        this.skillInfo = this.querySelector(
          '[data-booking-skill-info]'
        );

        this.referral = this.querySelector(
          '[data-booking-referral]'
        );

        this.referredByField = this.querySelector(
          '[data-booking-referred-by-field]'
        );

        this.referredBy = this.querySelector(
          '[data-booking-referred-by]'
        );

        this.submitButton = this.querySelector(
          '[data-booking-submit]'
        );

        this.error = this.querySelector(
          '[data-booking-error]'
        );

        this.backLink = this.querySelector(
          '[data-booking-back-link]'
        );

        if (!this.form || !this.variantInput) return;

        this.loadVariants();
        this.initializeVariant();
        this.initializeBackLink();
        this.initializeBirthdate();
        this.initializeSkill();
        this.initializeReferral();

        this.form.addEventListener(
          'submit',
          this.handleSubmit
        );
      }

      disconnectedCallback() {
        this.form?.removeEventListener(
          'submit',
          this.handleSubmit
        );

        this.backLink?.removeEventListener(
          'click',
          this.handleBackClick
        );
      }

      loadVariants() {
        this.variants = new Set();

        if (!this.variantsJson) return;

        try {
          const variants = JSON.parse(
            this.variantsJson.textContent
          );

          variants.forEach((variant) => {
            this.variants.add(String(variant.id));
          });
        } catch (error) {
          console.error(
            'peakride: Variantendaten konnten nicht geladen werden.',
            error
          );
        }
      }

      initializeVariant() {
        const requestedVariantId =
          new URLSearchParams(
            window.location.search
          ).get('variant');

        if (
          requestedVariantId &&
          this.variants.has(String(requestedVariantId))
        ) {
          this.variantInput.value =
            requestedVariantId;

          return;
        }

        const initialVariantId = String(
          this.dataset.initialVariantId || ''
        );

        if (this.variants.has(initialVariantId)) {
          this.variantInput.value =
            initialVariantId;
        }
      }

      initializeBackLink() {
        if (!this.backLink) return;

        const variantId =
          this.variantInput?.value;

        if (
          variantId &&
          this.dataset.productUrl
        ) {
          this.backLink.href =
            `${this.dataset.productUrl}?variant=${encodeURIComponent(variantId)}`;
        }

        this.backLink.addEventListener(
          'click',
          this.handleBackClick
        );
      }

      getBookingNavigation() {
        try {
          const rawNavigation =
            sessionStorage.getItem(
              'peakrideBookingNavigation'
            );

          if (!rawNavigation) return null;

          const navigation =
            JSON.parse(rawNavigation);

          const maximumAge =
            30 * 60 * 1000;

          if (
            !navigation.createdAt ||
            Date.now() - navigation.createdAt >
              maximumAge
          ) {
            sessionStorage.removeItem(
              'peakrideBookingNavigation'
            );

            return null;
          }

          const productUrl = new URL(
            this.dataset.productUrl,
            window.location.origin
          );

          if (
            navigation.productPath !==
            productUrl.pathname
          ) {
            return null;
          }

          const currentVariantId =
            String(
              this.variantInput?.value || ''
            );

          if (
            navigation.variantId &&
            String(navigation.variantId) !==
              currentVariantId
          ) {
            return null;
          }

          return navigation;
        } catch (error) {
          return null;
        }
      }

      handleBackClick = (event) => {
        const navigation =
          this.getBookingNavigation();

        if (!navigation) return;

        if (window.history.length <= 1) return;

        event.preventDefault();

        sessionStorage.removeItem(
          'peakrideBookingNavigation'
        );

        window.history.back();
      };

      initializeBirthdate() {
        if (!this.birthdate) return;

        this.birthdate.addEventListener(
          'input',
          () => {
            let value =
              this.birthdate.value
                .replace(/\D/g, '')
                .slice(0, 8);

            if (value.length > 4) {
              value =
                `${value.slice(0, 2)}.` +
                `${value.slice(2, 4)}.` +
                value.slice(4);
            } else if (value.length > 2) {
              value =
                `${value.slice(0, 2)}.` +
                value.slice(2);
            }

            this.birthdate.value = value;

            this.birthdate.setCustomValidity(
              ''
            );
          }
        );

        this.birthdate.addEventListener(
          'blur',
          () => {
            this.validateBirthdate();
          }
        );
      }

      validateBirthdate() {
        if (!this.birthdate) return true;

        const match =
          this.birthdate.value.match(
            /^(\d{2})\.(\d{2})\.(\d{4})$/
          );

        if (!match) {
          this.birthdate.setCustomValidity(
            'Bitte gib dein Geburtsdatum im Format TT.MM.JJJJ ein.'
          );

          return false;
        }

        const day =
          Number(match[1]);

        const month =
          Number(match[2]);

        const year =
          Number(match[3]);

        const date =
          new Date(
            year,
            month - 1,
            day
          );

        const isRealDate =
          date.getFullYear() === year &&
          date.getMonth() === month - 1 &&
          date.getDate() === day;

        if (!isRealDate) {
          this.birthdate.setCustomValidity(
            'Bitte gib ein gültiges Geburtsdatum ein.'
          );

          return false;
        }

        const today =
          new Date();

        today.setHours(
          0,
          0,
          0,
          0
        );

        if (date > today) {
          this.birthdate.setCustomValidity(
            'Das Geburtsdatum darf nicht in der Zukunft liegen.'
          );

          return false;
        }

        this.birthdate.setCustomValidity('');

        return true;
      }

      initializeSkill() {
        if (
          !this.skill ||
          !this.skillInfo
        ) {
          return;
        }

        const update = () => {
          const selectedOption =
            this.skill.options[
              this.skill.selectedIndex
            ];

          const description =
            selectedOption?.dataset
              ?.description || '';

          if (!description) {
            this.skillInfo.hidden = true;
            this.skillInfo.textContent = '';

            return;
          }

          this.skillInfo.textContent =
            description;

          this.skillInfo.hidden = false;
        };

        this.skill.addEventListener(
          'change',
          update
        );

        update();
      }

      initializeReferral() {
        if (
          !this.referral ||
          !this.referredByField ||
          !this.referredBy
        ) {
          return;
        }

        const update = () => {
          const wasReferred =
            this.referral.value ===
            'Freunde / Bekannte';

          this.referredByField.hidden =
            !wasReferred;

          this.referredBy.required =
            wasReferred;

          if (!wasReferred) {
            this.referredBy.value = '';
          }
        };

        this.referral.addEventListener(
          'change',
          update
        );

        update();
      }

      handleSubmit = async (event) => {
        event.preventDefault();

        this.validateBirthdate();

        if (!this.form.checkValidity()) {
          this.form.reportValidity();
          return;
        }

        if (!this.submitButton) return;

        const defaultButtonText =
          this.submitButton.textContent.trim();

        this.submitButton.disabled = true;

        this.submitButton.textContent =
          'Buchung wird vorbereitet …';

        if (this.error) {
          this.error.hidden = true;
        }

        try {
          const clearResponse =
            await fetch(
              this.dataset.cartClearUrl,
              {
                method: 'POST',
                headers: {
                  Accept:
                    'application/json'
                }
              }
            );

          if (!clearResponse.ok) {
            throw new Error(
              'Cart clear failed'
            );
          }

          const addResponse =
            await fetch(
              this.dataset.cartAddUrl,
              {
                method: 'POST',
                body:
                  new FormData(
                    this.form
                  ),
                headers: {
                  Accept:
                    'application/json'
                }
              }
            );

          if (!addResponse.ok) {
            throw new Error(
              'Cart add failed'
            );
          }

          sessionStorage.removeItem(
            'peakrideBookingNavigation'
          );

          window.location.assign(
            this.dataset.checkoutUrl
          );
        } catch (error) {
          console.error(
            'peakride: Buchung konnte nicht vorbereitet werden.',
            error
          );

          if (this.error) {
            this.error.hidden = false;
          }

          this.submitButton.disabled =
            false;

          this.submitButton.textContent =
            defaultButtonText;
        }
      };
    }
  );
}